module.exports = __webpack_public_path__ + "img/icon_map_61_on_111.88e1fe6d.png";